module.exports = __webpack_public_path__ + "static/media/home-it.246e9ce8.jpeg";